export default {
  super: [
    '110100',
    '310100',
    '440100',
    '440300'
  ],
  first: [
    '320500',
    '370200',
    '210200',
    '441900',
    '330200',
    '120100',
    '500100',
    '130100',
    '140100',
    '210100',
    '220100',
    '230100',
    '370100',
    '320100',
    '330100',
    '340100',
    '350100',
    '360100',
    '410100',
    '420100',
    '430100',
    '460100',
    '510100',
    '520100',
    '530100',
    '610100',
    '620100',
    '630100',
    '450100',
    '150100',
    '540100',
    '640100',
    '650100'
  ]
}



// WEBPACK FOOTER //
// ./src/data/cities.js